import $api from "@/frontend/shared/api/axios";
import { TDataRoomRow } from "../../ui/TableBody/TableBody";

export async function getDataroomData(): Promise<TDataRoomRow[]> {
  const response = await $api.get("/founders/data-room/files");
  return response.data.data;
}
